<form [formGroup]="recoveryForm">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-start" s-height-100vh>
      <!-- form -->
      <ion-col>
        <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form>
          <ion-col size="12">
            <h4
              class="text-primary ion-text-uppercase ion-text-md-capitalize ion-text-center ion-text-md-start"
              medium
            >
              {{"RECOVERY_PASSWORD.RECOVERY_PASSWORD" | translate}}
            </h4>
            <h5 class="text-primary ion-text-center ion-text-md-start" regular>
              {{"RECOVERY_PASSWORD.ENTER_YOUR_EMAIL_TO_SEND_US_A_PASSWORD_RECOVERY_REQUEST" | translate}}
            </h5>
          </ion-col>
          <ion-col size="12">
            <ion-label color="primary" type="email" position="stacked">{{"RECOVERY_PASSWORD.EMAIL" | translate}}</ion-label>
            <ion-input
              formControlName="email"
              placeholder='{{"RECOVERY_PASSWORD.ENTER_THE_LOGIN_EMAIL" | translate}}'
              (keyup.enter)="send(recoveryForm)"
            ></ion-input>

            <!-- email required -->
            <ion-note color="danger" class="margin-top text-center" *ngIf="email.dirty && email.errors?.required">
              {{"RECOVERY_PASSWORD.ENTER_YOUR_EMAIL" | translate}}
            </ion-note>

            <!-- email invalid -->
            <ion-note
            class="ion-margin-top ion-text-center"
              color="danger"
              *ngIf="email.dirty && email.errors?.email && !email.errors?.required"
            >
            {{"RECOVERY_PASSWORD.INVALID_EMAIL" | translate}}
            </ion-note>

            <!-- email max length -->
            <ion-note
            class="ion-margin-top ion-text-center"
              color="danger"
              *ngIf="email.dirty && !email.errors?.email && !email.errors?.required && email.errors?.maxlength"
            >
            {{"RECOVERY_PASSWORD.THE_EMAIL_MUST_CONTAIN_AT_MOST" | translate}} {{ email.errors.maxlength.requiredLength }}   {{"RECOVERY_PASSWORD.CHARACTERS" | translate}}
            </ion-note>
          </ion-col>
          <ion-col size="12">
            <ion-button expand="block" class="ion-margin-top" color="buttonPrimary" (click)="send(recoveryForm)"
              >{{"RECOVERY_PASSWORD.SEND_REQUEST" | translate}}</ion-button
            >
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
